module.exports = __webpack_public_path__ + "img/cart-plus.ef4ab49e.svg";